import React, { useRef, useEffect } from 'react';
import './Steps.css';

const StepIndicator = ({ currentStep, totalSteps }) => {
  const stepIndicatorRef = useRef(null);
  const currentStepRef = useRef(null);

  const steps = [
    { number: 1, title: 'Participanți' },
    { number: 2, title: 'Tip & Instructor' },
    { number: 3, title: 'Pachet' },
    { number: 4, title: 'Program' },
    { number: 5, title: 'Detalii' },
    { number: 6, title: 'Confirmare' }
  ];

  // Smart auto-scroll: start for first steps, center for middle steps, end for last steps
  useEffect(() => {
    if (currentStepRef.current && stepIndicatorRef.current) {
      const element = currentStepRef.current;
      
      let scrollBehavior = 'smooth';
      let alignPosition = 'center';
      
      // First two steps: align to start (left)
      if (currentStep <= 2) {
        alignPosition = 'start';
      }
      // Last two steps: align to end (right)
      else if (currentStep >= totalSteps - 1) {
        alignPosition = 'end';
      }
      // Middle steps: center
      else {
        alignPosition = 'center';
      }
      
      element.scrollIntoView({
        behavior: scrollBehavior,
        inline: alignPosition,
        block: 'nearest'
      });
    }
  }, [currentStep, totalSteps]);

  return (
    <div className="step-indicator" ref={stepIndicatorRef}>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div 
            ref={currentStep === step.number ? currentStepRef : null}
            className={`step-item ${currentStep >= step.number ? 'active' : ''} ${currentStep === step.number ? 'current' : ''}`}
          >
            <div className="step-circle">
              {currentStep > step.number ? '✓' : step.number}
            </div>
            <div className="step-title">{step.title}</div>
          </div>
          {index < steps.length - 1 && (
            <div className={`step-line ${currentStep > step.number ? 'active' : ''}`}></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;